import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Apropos from '@/views/About.vue'
import Contact from '@/views/Contact.vue'
import Realisation from '@/views/Realisation.vue'
import Experiences from '@/views/Experiences.vue'
import Competences from '@/views/Competences.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		
	},
	{
		path: '/apropos',
		name: 'A Propos',
		component: Apropos,
		props: {sidebar: 'right',position:'1',count:'2'}
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact,
		props: {sidebar: 'right',position:'2',count:'2'}
	},
	{
		path: '/realisations',
		name: 'Realisation',
		component: Realisation,
		props: {sidebar: 'left',position:'2',count:'3'}
	},
	{
		path: '/experiences',
		name: 'Experiences',
		component: Experiences,
		props: {sidebar: 'left',position:'1',count:'3'}
	},
	{
		path: '/competences',
		name: 'Competences',
		component: Competences,
		props: {sidebar: 'left',position:'3',count:'3'}
	}
];

const router = new VueRouter({
	routes
});

export default router
